<template>

    <div class="my-6">
        <label for="comment" class="block text-sm font-medium text-gray-700"> Material Type</label>
        <div class="my-3">
            <ListBoxSelectWithImage :options="typeDiecast" v-model="form.typeDiecast" requires="True" />
        </div>

        <div class="my-3">
            <ListBoxSelectWithImage v-if="form.typeDiecast == 'Standard Diecast'" :options="standardDiecast"
                v-model="form.typeDiecastSubSelection" />

            <ListBoxSelectWithImage v-if="form.typeDiecast == 'Watertight Light Duty'" :options="watertightLightDuty"
                v-model="form.typeDiecastSubSelection" />

            <ListBoxSelectWithImage v-if="form.typeDiecast == 'Watertight Heavy Duty'" :options="watertightHeavyDuty"
                v-model="form.typeDiecastSubSelection" />

        </div>

        <div v-if="form.typeDiecast == 'Other'">
            <BaseTextArea
                label="Please tell us about the material you require. We can source material as a non-stock request, for additional leadtime and cost. "
                v-model="form.typeDiecastOther"
                tooltip="We can source different material as a non-stock request, for additional leadtime and cost." />
        </div>

        <div class="my-3">

            <ListBoxSelectWithImage :options="typeMaterialFinish" v-model="form.typeMaterialFinish"
                labelMain="Finish Type" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterialFinish == `Bare-Metal Finish`"
                :options="typeMaterialFinishBareMetal" v-model="form.finishType" />

            <ListBoxSelectWithImage v-if="form.typeMaterialFinish == `Powdercoat Finish`"
                :options="typeMaterialFinishPowderCoat" v-model="form.finishType" placeholder="Select Option" />

            <BaseInput v-if="form.typeMaterialFinishType == 'Other'"
                label="Please indicate the powdercoat color you require"
                placeholder="Please indicate the powdercoat color you require" v-model="form.otherPowderCoat" />

            <BaseRadioButtonGroup :options="yesNo" v-model="form.reqGraphics" label="Do you require graphics? "
                requires="True" />

            <BaseRadioButtonGroup v-if="form.reqGraphics == 'Yes'" :options="reqGraphics" v-model="form.reqGraphicsType"
                label="Which type of graphics do you require? " requires="True" />

            <!-- If graphics is required starts -->
            <BaseRadioButtonGroup
                v-if="(form.reqGraphicsType == 'Quote for Both' || form.reqGraphicsType == 'Digital Print')"
                :options="digitalPrint" v-model="form.DigitalPrint" label="Which type of digital print do you require?"
                requires="True" />
            <!-- If graphics is required ends -->

            <BaseRadioButtonGroup :options="reqPermanentMarking" v-model="form.reqPermanentMarking"
                label="Does your design require Permanent Marking? " requires="True" />

            <!-- If permanent marking is required starts -->
            <div v-if="form.reqPermanentMarking == 'Yes'">
                <BaseRadioButtonGroup :options="typePermanentMarking" v-model="form.PermanentMarking"
                    label="Which permanent marking are you looking for? " requires="True" />
            </div>

            <div v-if="form.PermanentMarking == 'Laser Marking' || form.PermanentMarking == 'Quote all options' ">
                <label class="block text-sm font-medium text-gray-700"> Which types of Laser Marking do you want
                    quoted?</label>


                <div class="origin-center my-2">
                    <input type="checkbox" value="Engrave" id="Engrave"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.DiecastLaserMarking" />
                    <label for="Engrave">Engrave</label>
                    <input type="checkbox" value="Burn" id="Burn"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.DiecastLaserMarking" />
                    <label for="Burn">Burn</label>
                    <input type="checkbox" value="Silver" id="Silver"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.DiecastLaserMarking" />
                    <label for="Silver">Silver</label>
                    <input type="checkbox" value="Outline" id="Outline"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.DiecastLaserMarking" />
                    <label for="Outline">Outline</label>
                    <input type="checkbox" value="Ablate" id="Ablate"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.DiecastLaserMarking" />
                    <label for="Ablate">Ablate</label>
                    <input type="checkbox" value="Anneal" id="Anneal"
                        class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        v-model="form.DiecastLaserMarking" />
                    <label for="Anneal">Anneal</label>
                </div>
            </div>

            <!-- If permanent marking is required ends -->


            <BaseRadioButtonGroup v-if="(form.reqPermanentMarking == 'Yes' || form.reqGraphics == 'Yes')"
                :options="yesNo" :group="`artwork`" label="Is your artwork finalized?"
                v-model="form.artworkFinalized" />

            <div v-if="form.artworkFinalized == 'Yes'" class="my-6">
                <FileComponent label="Please upload your CAD file" @uploaded="handleFileUpload" />
            </div>



        </div>



    </div>

</template>

<script setup>
import { inject } from 'vue';

import BaseSelect from '../formComponents/BaseSelect.vue';
import BaseInput from '../formComponents/BaseInput.vue';
import BaseTextArea from '../formComponents/BaseTextArea.vue';



import {
    typeDiecast, standardDiecast, watertightHeavyDuty, watertightLightDuty
} from '../../constants/customizableDieCastEnc';

import { typeMaterialFinish, typeMaterialFinishBareMetal, typeMaterialFinishPowderCoat, typeMaterialAluminumOnly, typeMaterialStainlessSteelOnly, typeMaterialCopperOnly } from '../../constants/finish';
import BaseRadioButtonGroup from '../formComponents/BaseRadioButtonGroup.vue';
import ListBoxSelectWithImage from '../formComponents/ListBoxSelectWithImage.vue';
import { yesNo } from '../../constants/options';
import FileComponent from '../formComponents/FileComponent.vue';


const form = inject('form');

form.DiecastLaserMarking = [];

const handleFileUpload = (file) => {
    form.customizableDiecastGraphic = file;
    form.customizableDiecastGraphicName = file.name;
}


const typeGraphics = [
    { 'title': 'Digital Print', "group": 'graphics' },
    { 'title': 'Silkscreen', "group": 'graphics' },
]

const typePermanentMarking = [
    { 'title': 'Laser Marking', "group": 'graphics' },
    { 'title': 'Dot Peening', "group": 'graphics' },
    { 'title': 'Engrave and Fill', 'id': 'Engrave and Fill', "group": 'graphics' },
    { 'title': 'Quote all options', 'id': 'Quote all options', "group": 'graphics' }
]

const reqGraphics = [
    { 'title': 'Digital Print', "group": 'reqGraphics' },
    { 'title': 'Silkscreen', "group": 'reqGraphics' },
    { 'title': 'Quote for Both', "group": 'reqGraphics' },
]
const reqPermanentMarking = [
    { 'title': 'Yes', "group": 'reqPermanentMarking' },
    { 'title': 'No', "group": 'reqPermanentMarking' },
]

const digitalPrint = [
    { 'title': 'Standard Resolution (720 dpi)', "group": 'digitalPrint' },
    { 'title': 'Premium Resolution (1440 dpi)', "group": 'digitalPrint' },
    { 'title': 'Quote for Both', "group": 'digitalPrint' },
]

const typeLaserMarking = [
    { 'title': 'Engrave' },
    { 'title': 'Burn' },
    { 'title': 'Silver' },
    { 'title': 'Outline' },
    { 'title': 'Ablate' },
    { 'title': 'Anneal' },
]





</script>